"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PlaybackPlay = function PlaybackPlay(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M7.904 5.818l11.248 5.624a.625.625 0 010 1.118L7.904 18.184a.625.625 0 01-.905-.559V6.377a.625.625 0 01.905-.559z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(PlaybackPlay);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PlaybackPlay, "PlaybackPlay", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PlaybackPlay.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PlaybackPlay.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9QbGF5YmFja1BsYXkudHN4Il0sIm5hbWVzIjpbIlBsYXliYWNrUGxheSIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxZQUE0RSxHQUFHLFNBQS9FQSxZQUErRSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUNuRjtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsbUhBREo7QUFFRSxJQUFBLElBQUksRUFBQztBQUZQLElBREYsQ0FEbUY7QUFBQSxDQUFyRjs7ZUFTZSx1QkFBV0YsWUFBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxZIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBQbGF5YmFja1BsYXk6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk03LjkwNCA1LjgxOGwxMS4yNDggNS42MjRhLjYyNS42MjUgMCAwMTAgMS4xMThMNy45MDQgMTguMTg0YS42MjUuNjI1IDAgMDEtLjkwNS0uNTU5VjYuMzc3YS42MjUuNjI1IDAgMDEuOTA1LS41NTl6XCJcbiAgICAgIGZpbGw9XCJjdXJyZW50Q29sb3JcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihQbGF5YmFja1BsYXkpO1xuIl19